export var usePagination = function (setPage, setLimit, callRoles) {
    var onChangePage = function (page) {
        setPage(page);
        callRoles(true);
    };
    var onChangeLimit = function (limit) {
        setLimit(limit);
        callRoles(true);
    };
    return { onChangePage: onChangePage, onChangeLimit: onChangeLimit };
};
